import { useState, useEffect ,useRef, use} from "react";
import SearchBar from "./SearchBar";
import { Modal } from "react-bootstrap";
import VideoPlayer from "./VideoPlayer";
import Fuse from "fuse.js";
import nlp from "compromise";
import SkeletonLoader from "./Skeleton";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import APP_CONFIG from "./Config";


const VideoList = ({ selectedTopic, displayName }) => {
  const [videos, setVideos] = useState([]);
  const [filteredVideos, setFilteredVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [initial, setInitial] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState("User");
  const [realVideo, setRealVideo] = useState([]);
  const [initialVideo, setInitialVideo] = useState([]);
  const navigate = useNavigate();
  

  useEffect(() => {
    setLoading(true);
    fetch(APP_CONFIG.BACKEND_URL + "videos", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok " + response.statusText);
        }
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          setRealVideo(data.videos);
          setInitialVideo(data.videos);
          setInitial(true);
          setVideos(data.videos);
          setFilteredVideos(data.videos);
        } else {
          setRealVideo([]);
          setInitialVideo([]);
          setInitial(false);
          setVideos([]);
          setFilteredVideos([]);
          toast.error("Error fetching videos:", data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching videos:", error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  

  const handleVideoClick = (video) => {
    setSelectedVideo(video);
    setShowModal(true);
  };

  
  const extractedTopics = (query) => {
    return nlp(query).nouns().out("text");
  };


  const isFirstLoad = useRef(true);

  useEffect(() => {
const user = Cookies.get("customerName");
    if (user) {
      setUserName(user);
    } 
  },[]);

  const logoutFunction = () => {
      Cookies.remove("token");
      Cookies.remove("customerName");
      localStorage.removeItem("userProducts");
      toast.info("You have been logged out.");
      navigate("/");
    };

 useEffect(() => {
  if (realVideo.length === 0) {
    setLoading(true);
    return;
  }

  if (!selectedTopic) {
    setVideos([]);
    setFilteredVideos([]);
    setInitial(true);
    setLoading(false);
    return;
  }
  const topicVideos = realVideo.filter(video => video.moduleId === selectedTopic);
  setInitial(false);
  setVideos(topicVideos);
  setFilteredVideos(topicVideos);
  setSearchQuery("");
  setLoading(false);
}, [selectedTopic, realVideo]);


  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredVideos(videos);
      setInitialVideo(realVideo);
    } else {
      const cleanedQuery = extractedTopics(searchQuery);
      const options = {
        keys: ["title", "description","eventKeywords"],
        threshold: 0.4,
      };

      const fuse = new Fuse(videos, options);
      const fuse2 = new Fuse(realVideo, options);
      if(initial){
        setInitialVideo(fuse2.search(cleanedQuery).map((r) => r.item))
      }
      else{
        setFilteredVideos(fuse.search(cleanedQuery).map((r) => r.item));
      }
      
    }
  }, [searchQuery, videos]);

  return (
    <div className="container mt-4">
      {/* <div className="d-flex justify-content-end"><img src="./logo-profile.webp" height={45} alt="profile Logo"/></div> */}
      <div className="col-12" style={{display:"flex", alignItems:"center",justifyContent:'center'}}>
        <div className="col-10"><h1 className="VideoMainTitle">{displayName} Video Library</h1></div>
        <div className="col-2 LogoMainTitle">
          {/* <img src="./logo-profile.webp" height={45} alt="profile Logo"/> */}
         <div>
          <button
            className="btn  dropdown-toggle d-flex  p-2"
            type="button"
            id="userDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            style={{color:'black',outline:'none',border:'none',display:'flex',alignItems:'center',justifyContent:'center',width:'45px',borderRadius:'50%',height:'45px'}}
          >
            {/* <span className="text-black" style={{fontSize:'1.3rem',fontWeight:'500'}}>User</span> &nbsp; &nbsp; */}
            <img src="./logo-profile.webp" height={45} alt="profile Logo"/>
            
          </button>
          <ul className="dropdown-menu dropdown-menu-end text-white" aria-labelledby="userDropdown"  style={{color:'white'}} >
            <li>
              <span className="dropdown-item">
               <b>User :</b> {userName}
              </span>
            </li>
            <li>
              <hr className="dropdown-divider" />
            </li>
            <li>
              <a className="dropdown-item text-danger" onClick={logoutFunction} style={{cursor:'pointer'}}>
                Logout
              </a>
            </li>
          </ul>
          </div>
       
        </div>
      </div>
      
      <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />

      <main className="bg-white p-4 shadow rounded-bottom">
        <div className="row g-4">
          {loading?(
            <SkeletonLoader  count={6} /> 
          ):(
            <>
              

{initial ? (
  <>
    {initialVideo && initialVideo.length > 0 ? (
      initialVideo.map((video) => (
        <div
          key={video.videoId}
          className="col-lg-4 col-md-12 col-sm-12 videoContainer"
          onClick={() => handleVideoClick(video)}
        >
          <div className="card h-100 shadow-sm">
            <img
              src={`data:image/png;base64,${video.thumbnail}`}
              alt={video.title}
              className="card-img-top"
              style={{ height: "50%", objectFit: "cover", width: "100%" }}
              onError={(e) => (e.target.src = "/videoPlaceholder.png")}
            />
            <div className="card-body position-relative">
              <h5
                className="card-title"
                style={{
                  color: "rgb(2 75 155)",
                  fontFamily: "poppins",
                  borderTop: "2px solid rgb(2 75 155)",
                  paddingTop: "10px",
                  fontSize: "1.1rem",
                }}
              >
                {video.title}
              </h5>
              <p className="card-text text-muted">{video.description}</p>
              <span className="badge bg-secondary position-absolute bottom-0 start-0 m-3">
                {video.duration}
              </span>
            </div>
          </div>
        </div>
      ))
    ) : (
      <p className="text-center text-muted">No videos found for this topic.</p>
    )}
  </>
) : (
  <>
    {filteredVideos && filteredVideos.length > 0 ? (
      filteredVideos.map((video) => (
        <div
          key={video.videoId}
          className="col-lg-4 col-md-12 col-sm-12 videoContainer"
          onClick={() => handleVideoClick(video)}
        >
          <div className="card h-100 shadow-sm">
            <img
              src={`data:image/png;base64,${video.thumbnail}`}
              alt={video.title}
              className="card-img-top"
              style={{ height: "50%", objectFit: "cover", width: "100%" }}
              onError={(e) => (e.target.src = "/videoPlaceholder.png")}
            />
            <div className="card-body position-relative">
              <h5
                className="card-title"
                style={{
                  color: "rgb(2 75 155)",
                  fontFamily: "poppins",
                  borderTop: "2px solid rgb(2 75 155)",
                  paddingTop: "10px",
                  fontSize: "1.1rem",
                }}
              >
                {video.title}
              </h5>
              <p className="card-text text-muted">{video.description}</p>
              <span className="badge bg-secondary position-absolute bottom-0 start-0 m-3">
                {video.duration}
              </span>
            </div>
          </div>
        </div>
      ))
    ) : (
      <p className="text-center text-muted">No videos found for this topic.</p>
    )}
  </>
)}

            </>

          )}
          
         
        </div>
      </main>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
      >
        <Modal.Header className="bg-dark text-white d-flex justify-content-between align-items-center">
          <Modal.Title className="fw-bold">{selectedVideo?.title}</Modal.Title>
          <button
            onClick={() => setShowModal(false)}
            className="btn btn-danger btn-sm px-3 fw-bold shadow-sm"
          >
            ✖
          </button>
        </Modal.Header>

        <Modal.Body className="text-center bg-light">
          {selectedVideo && (
            <VideoPlayer
              videoUrl={`https://learn.prowesserp.com/temp/`}
              topic={`${selectedTopic}`}
              id={`${selectedVideo.fileName}`}
            />
            // <VideoPlayerNew videoUrl={`https://www.drivehq.com/file/df.aspx/publish/rohittttz/myVideo/sampleVideo.m3u8`} />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default VideoList;
